import ApiClient from "../../../apiClient";
import { BASE_URL, SEARCH, EMPLOYEE, ROLES, USER } from "../../../constant/apiEndPoint";
import CustomMessage from "../../../utils/CustomMessage";
import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import { checkSession } from "../auth/AuthActions";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

export const getEmployeeAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${EMPLOYEE.getAllEmployee}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_EMPLOYEE_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_EMPLOYEE_FAIL,
          payload: CustomMessage(error.status),
        });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const createEmployeeAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${EMPLOYEE.createEmployee}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "success",
          message: response.data.result.message,
          options: { autoClose: 3000, position: "top-center" },
        });
        dispatch({ type: TYPE.CREATE_EMPLOYEE_SUCCESS, payload: response?.data });
        navigate("/users");
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({ type: TYPE.CREATE_EMPLOYEE_FAIL, payload: error?.data?.result?.message });
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getEmployeeRoleAction = (navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${ROLES.getAllRoles}`, {}, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({ type: TYPE.GET_EMPLOYEE_ROLE_SUCCESS, payload: response.data.result.data });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({
          type: TYPE.GET_EMPLOYEE_ROLE_FAIL,
          payload: {},
        });
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getEmployeeByIdAction = (emp_id, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${EMPLOYEE.getEmployeeDetailsById}=${emp_id}`, {}, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_EMPLOYEE_BY_ID_SUCCESS,
          payload: response.data.result.data,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({ type: TYPE.GET_EMPLOYEE_BY_ID_FAIL, payload: error?.data?.result?.message });
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const deleteEmployeeAction = (emp_id, navigate, newEmpPayload) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.delete(`${BASE_URL}${EMPLOYEE.deleteEmployee}=${emp_id}`, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "success",
          message: response.data.result.message,
          options: { autoClose: 2000, position: "top-center" },
        });
        dispatch({
          type: TYPE.DELETE_EMPLOYEE_SUCCESS,
          payload: response.data.result.message,
        });
        dispatch(getEmployeeAction(newEmpPayload, navigate));
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({
          type: TYPE.DELETE_EMPLOYEE_FAIL,
          payload: error?.data?.result?.message,
        });
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
        dispatch(getEmployeeAction());
      });
  };
};

export const updateEmployeeAction = (payload, emp_id, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${EMPLOYEE.updateEmployeeById}=${emp_id}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "success",
          message: response.data.result.message,
          options: { autoClose: 5000, position: "top-center" },
        });
        dispatch({
          type: TYPE.UPDATE_EMPLOYEE_SUCCESS,
          payload: response.data.result.message,
        });
        navigate("/users");
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({
          type: TYPE.UPDATE_EMPLOYEE_FAIL,
          payload: error?.data?.result?.message,
        });
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const deactivateEmployeeAction = (payload, emp_id, navigate, getEmpPayload) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.put(`${BASE_URL}${EMPLOYEE.deactivateEmployee}=${emp_id}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "success",
          message: response.data.result.message,
          options: { autoClose: 5000, position: "top-center" },
        });
        dispatch({
          type: TYPE.ACTIVATE_DEACTIVATE_EMPLOYEE_SUCCESS,
          payload: response.data.result.message,
        });
        dispatch(getEmployeeAction(getEmpPayload, navigate));
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({
          type: TYPE.ACTIVATE_DEACTIVATE_EMPLOYEE_FAIL,
          payload: error?.data?.result?.message,
        });
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const getFilteredEmployeeAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${SEARCH.ADMIN_SEARCH}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_EMPLOYEE_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_EMPLOYEE_FAIL,
          payload: [],
        });
        // CustomToast({
        //   type: "error",
        //   message: CustomMessage(error.status),
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};





export const getStateCityAction = (payload) => {
  return ApiClient.post(`${BASE_URL}${USER.GET_STATE_CITY}`, payload, true)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
